import { useState } from 'react';
import { useIntl } from 'react-intl';
import Fade from '../Fade';
import FilterMenu from './FilterMenu';
import { MdOutlineFilterList } from 'react-icons/md';

const FilterSelector = (props) => {
  const { filters = [] } = props;
  const intl = useIntl();
  const [hide, setHide] = useState(true);
  const handleShowHide = () => {
    setHide(!hide);
  };
  return (
    <div className="drs-container">
      <div>
        <button
          data-testid="filtersMenu"
          className={`button filter-button primary ${hide ? ' inverted' : ''}`}
          onClick={handleShowHide}
        >
          <MdOutlineFilterList />
          {intl.formatMessage({ id: 'filter' })}
        </button>
        <Fade hide={hide}>
          <FilterMenu
            filters={filters}
            handleShowHide={handleShowHide}
            additionalOptions={props.additionalOptions}
            removeItems={props.removeItems}
          />
        </Fade>
      </div>
    </div>
  );
};

FilterSelector.defaultProps = {
  disabled: false,
  isLoading: false,
};

export default FilterSelector;
